import { render, staticRenderFns } from "./CadastralForm.vue?vue&type=template&id=2df289cc&scoped=true&"
import script from "./CadastralForm.vue?vue&type=script&lang=js&"
export * from "./CadastralForm.vue?vue&type=script&lang=js&"
import style0 from "./CadastralForm.vue?vue&type=style&index=0&id=2df289cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df289cc",
  null
  
)

export default component.exports